/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskProgressDto } from './TaskProgressDto';
import {
    TaskProgressDtoFromJSON,
    TaskProgressDtoFromJSONTyped,
    TaskProgressDtoToJSON,
    TaskProgressDtoToJSONTyped,
} from './TaskProgressDto';

/**
 * 
 * @export
 * @interface ImportProgressDtoTasks
 */
export interface ImportProgressDtoTasks {
    /**
     * 
     * @type {TaskProgressDto}
     * @memberof ImportProgressDtoTasks
     */
    validation?: TaskProgressDto;
    /**
     * 
     * @type {TaskProgressDto}
     * @memberof ImportProgressDtoTasks
     */
    staging?: TaskProgressDto;
    /**
     * 
     * @type {TaskProgressDto}
     * @memberof ImportProgressDtoTasks
     */
    committing?: TaskProgressDto;
    /**
     * 
     * @type {TaskProgressDto}
     * @memberof ImportProgressDtoTasks
     */
    geocoding?: TaskProgressDto;
    /**
     * 
     * @type {TaskProgressDto}
     * @memberof ImportProgressDtoTasks
     */
    osmPopulation?: TaskProgressDto;
}

/**
 * Check if a given object implements the ImportProgressDtoTasks interface.
 */
export function instanceOfImportProgressDtoTasks(value: object): value is ImportProgressDtoTasks {
    return true;
}

export function ImportProgressDtoTasksFromJSON(json: any): ImportProgressDtoTasks {
    return ImportProgressDtoTasksFromJSONTyped(json, false);
}

export function ImportProgressDtoTasksFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportProgressDtoTasks {
    if (json == null) {
        return json;
    }
    return {
        
        'validation': json['Validation'] == null ? undefined : TaskProgressDtoFromJSON(json['Validation']),
        'staging': json['Staging'] == null ? undefined : TaskProgressDtoFromJSON(json['Staging']),
        'committing': json['Committing'] == null ? undefined : TaskProgressDtoFromJSON(json['Committing']),
        'geocoding': json['Geocoding'] == null ? undefined : TaskProgressDtoFromJSON(json['Geocoding']),
        'osmPopulation': json['OsmPopulation'] == null ? undefined : TaskProgressDtoFromJSON(json['OsmPopulation']),
    };
}

export function ImportProgressDtoTasksToJSON(json: any): ImportProgressDtoTasks {
    return ImportProgressDtoTasksToJSONTyped(json, false);
}

export function ImportProgressDtoTasksToJSONTyped(value?: ImportProgressDtoTasks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Validation': TaskProgressDtoToJSON(value['validation']),
        'Staging': TaskProgressDtoToJSON(value['staging']),
        'Committing': TaskProgressDtoToJSON(value['committing']),
        'Geocoding': TaskProgressDtoToJSON(value['geocoding']),
        'OsmPopulation': TaskProgressDtoToJSON(value['osmPopulation']),
    };
}

